// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1iaTD","select":"Header_select__2pSZS","clinic":"Header_clinic__37rjb"};